import RemoveStyleColorsWithoutQuantities from './RemoveStyleColorsWithoutQuantities.container'

export default RemoveStyleColorsWithoutQuantities
